import React from "react";

export default function Plan({ plan, onClick, variant = "primary" }) {
  return (
    <div
      className={`shadow-[0_6px_12px_-2px_rgba(0,0,0,0.5)] cursor-pointer border-2 rounded-lg p-6 shadow-md transition duration-300 ${
        variant === "primary"
          ? "bg-white border-black text-black"
          : "border-gray-200"
      }`}
    >
      <h2 className="text-xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl leading-none font-semibold mb-2.5">
        {plan.name}
      </h2>
      <p className="text-xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl leading-none font-bold mb-2.5">
        ${plan.price}
        {plan.isMonthly ? "/month" : ""}
      </p>
      <p className="text-sm mb-6">{plan.desc}</p>

      <button
        className={"w-full border-2 py-2 mb-4 rounded-lg bg-black text-white"}
        onClick={onClick}
      >
        Pay
      </button>

      <hr className="my-4" />

      <ul className="list-disc list-inside space-y-1">
        {plan.features.map((f, i) => (
          <li key={i} className="flex items-center gap-2">
            <span>
              <svg
                className="size-[2ch] text-inherit"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </span>
            <span>{f}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
